import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Popular} from '../../../../../models/search/filter/popular';
import {QueryStringService} from '../../../../../services/query-string.service';

@Component({
  selector: 'app-popular',
  templateUrl: './popular.component.html',
})
export class PopularComponent implements OnInit {

  @Input() data: Popular[];
  @Output() update = new EventEmitter<any>();

  constructor(
      private QSS: QueryStringService
  ) { }

  ngOnInit() {
  }

  isActive(item: Popular) {
    return (this.QSS.getParam('models') === item.model && this.QSS.getParam('version') === item.version);
  }

  updateEvent($event: Event, item: Popular) {
    if (item === null) {
      this.update.emit({name: 'models', 'value': null});
      this.update.emit({name: 'version', 'value': null});
    } else {
      if (!$($event.target).hasClass('icon-x') && !$($event.target).hasClass('btn-delete')) {
        if (!this.isActive(item)) {
          this.update.emit({name: 'models', 'value': item.model});
          this.update.emit({name: 'version', 'value': item.version});
        }
      }
    }
  }
}
